import React from 'react';
import { Box, Typography, Grid, Link, TextField, Button, InputAdornment } from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn, Email } from '@mui/icons-material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Phone, Person } from '@mui/icons-material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Footer = () => {
    const commonStyles = {
        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
        transition: 'all 0.3s ease',
    };

    return (
        <Box sx={{ backgroundColor: '#233098', color: 'white', padding: 0 }}>
            {/* Subscription Section */}
            <Box sx={{
                backgroundColor: '#f4f4f5',
                color: 'black',
                padding: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                textAlign: 'center',
                marginBottom: 4
            }}>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", marginTop: 3, marginBottom: 2 }}>Subscribe to Our Newsletter</Typography>
                    <Typography sx={{ fontSize: '18px', color: '#233098', marginBottom: 2, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Subscribe to Our Newsletter for Exclusive Updates and Opportunities</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', md: 'row' }, marginTop: 2, marginBottom: 2 }}>

                    <TextField
                        variant="outlined"
                        placeholder="Enter your name"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Person sx={{ color: '#233098', fontSize: '20px' }} />
                                </InputAdornment>
                            ),
                            sx: {
                                color: '#233098',
                                '& .MuiOutlinedInput-root': {
                                    fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    '& fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                },
                            },
                        }}
                        sx={{
                            marginBottom: { xs: '5px', md: 0 },
                            marginRight: { md: '10px' },
                            input: { color: '#233098', fontSize: '16px' },
                            width: { xs: '100%', md: '250px' }
                        }}
                    />
                    <TextField
                        variant="outlined"
                        placeholder="Enter your phone number"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Phone sx={{ color: '#233098', fontSize: '20px' }} />
                                </InputAdornment>
                            ),
                            sx: {
                                color: '#233098',
                                '& .MuiOutlinedInput-root': {
                                    fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    '& fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                },
                            },
                        }}
                        sx={{
                            marginBottom: { xs: '5px', md: 0 },
                            marginRight: { md: '10px' },
                            input: { color: '#233098', fontSize: '16px' },
                            width: { xs: '100%', md: '250px' },
                            fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                        }}
                    />
                    <TextField
                        variant="outlined"
                        placeholder="Enter your email"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Email sx={{ color: '#233098', fontSize: '20px' }} />
                                </InputAdornment>
                            ),
                            sx: {
                                color: '#233098',
                                '& .MuiOutlinedInput-root': {
                                    fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    '& fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#233098',
                                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                                    },
                                },
                            },
                        }}
                        sx={{
                            marginBottom: { xs: '5px', md: 0 },
                            marginRight: { md: '10px' },
                            input: { color: '#233098', fontSize: '16px' },
                            width: { xs: '100%', md: '250px' }
                        }}
                    />
                    <Button variant="contained" sx={{
                        backgroundColor: '#233098',
                        color: 'white',
                        height: '56px',
                        fontSize: '14px',
                        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                        width: { xs: '100%', md: '250px' },
                        '&:hover': { backgroundColor: '#233098' }
                    }}>
                        SUBSCRIBE NOW
                    </Button>
                </Box>
            </Box>

            {/* Main Content Section */}
            <Box sx={{ padding: '20px' }}>
                <Grid container spacing={6}> {/* Reduced grid spacing */}
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>ABOUT COMPANY</Typography>
                        <hr style={{ border: '2px solid #ffffff', width: '70px', margin: '0', marginBottom: '8px' }} />
                        <Typography sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }} >
                            Professionally redefine transparent ROI through low-risk high-yield imperatives.
                            Progressively create empowered, cost-effective users via team driven.
                        </Typography>
                        <Box sx={{ display: 'flex', marginTop: '16px' }}>
                            <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'inline-flex', marginRight: '16px', '&:hover': { color: '#ffffff', transform: 'translateY(-6px) scale(1.2)', filter: 'drop-shadow(0px 5px 8px rgba(255,255,255,0.5))' } }}><Facebook sx={{ fontSize: '28px' }} /></Link>
                            <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'inline-flex', marginRight: '16px', '&:hover': { color: '#ffffff', transform: 'translateY(-6px) scale(1.2)', filter: 'drop-shadow(0px 5px 8px rgba(255,255,255,0.5))' } }}><Twitter sx={{ fontSize: '28px' }} /></Link>
                            <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'inline-flex', marginRight: '16px', '&:hover': { color: '#ffffff', transform: 'translateY(-6px) scale(1.2)', filter: 'drop-shadow(0px 5px 8px rgba(255,255,255,0.5))' } }}><Instagram sx={{ fontSize: '28px' }} /></Link>
                            <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'inline-flex', '&:hover': { color: '#ffffff', transform: 'translateY(-6px) scale(1.2)', filter: 'drop-shadow(0px 5px 8px rgba(255,255,255,0.5))' } }}><LinkedIn sx={{ fontSize: '28px' }} /></Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>QUICK LINKS</Typography>
                        <hr style={{ border: '2px solid #ffffff', width: '70px', margin: '0', marginBottom: '8px' }} />
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />About Us</Link>
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />Team</Link>
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />FAQ</Link>
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />Projects</Link>
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />Contact Us</Link>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>IT SERVICES</Typography>
                        <hr style={{ border: '2px solid #ffffff', width: '70px', margin: '0', marginBottom: '8px' }} />
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />Web Development</Link> {/* Reduced margin bottom */}
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />Business Development</Link>
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />Product Management</Link>
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />UI/UX Design</Link>
                        <Link href="#" color="inherit" sx={{ ...commonStyles, display: 'flex', alignItems: 'center', marginBottom: '4px', '&:hover': { color: '#ffffff', transform: 'translateX(8px)' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}><ChevronRightIcon sx={{ fontSize: '18px', marginRight: '4px' }} />Cloud Services</Link>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', color: '#fff' }}>Contact Us</Typography>
                        <hr style={{ border: '2px solid #ffffff', width: '70px', margin: '0', marginBottom: '8px' }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff' }}>
                            <EmailIcon sx={{ marginRight: '8px' }} />
                            <Box>
                                <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Email:</Typography>
                                <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>info@sninfosystems.com</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff' }}>
                            <PhoneIcon sx={{ marginRight: '8px' }} />
                            <Box>
                                <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Phone:</Typography>
                                <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>+91 9740857368</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
                            <WhatsAppIcon sx={{ marginRight: '8px' }} />
                            <Box>
                                <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>WhatsApp:</Typography>
                                <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>+91 9740857368</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff' }}>
                            <LocationOnIcon sx={{ marginRight: '8px' }} />
                            <Box>
                                <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Address:</Typography>
                                <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Basavanagudi,Bangaluru,Karnataka</Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* Footer Bottom Section */}
            <Box sx={{ textAlign: 'center', padding: '10px' }}>
                <Typography sx={{ fontWeight: 700, color: '#fff', fontSize: '14px', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
                    Copyright &copy; 2026 SN Info Systems. All Rights Reserved.
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;











// import React from 'react';
// import { Box, Typography, Grid, Link, TextField, Button, InputAdornment } from '@mui/material';
// import { Facebook, Twitter, Instagram, LinkedIn, Email } from '@mui/icons-material';
// import EmailIcon from '@mui/icons-material/Email';
// import PhoneIcon from '@mui/icons-material/Phone';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import { Phone, Person } from '@mui/icons-material';

// const Footer = () => {
//     const commonStyles = {
//         fontFamily: 'Arial, sans-serif',
//     };

//     return (
//         <Box sx={{ backgroundColor: '#233098', color: 'white', padding: 0 }}>
//             {/* Subscription Section */}
//             <Box sx={{
//                 backgroundColor: '#f4f4f5',
//                 color: 'black',
//                 padding: '20px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 flexDirection: 'column',
//                 textAlign: 'center',
//                 marginBottom: 4
//             }}>
//                 <Box>
//                     <Typography variant="h5" sx={{ fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", marginTop: 3, marginBottom: 2 }}>Subscribe to Our Newsletter</Typography>
//                     <Typography sx={{ fontSize: '18px', color: '#233098', marginBottom: 2, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Subscribe to Our Newsletter for Exclusive Updates and Opportunities</Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', md: 'row' }, marginTop: 2, marginBottom: 2 }}>

//                     <TextField
//                         variant="outlined"
//                         placeholder="Enter your name"
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <Person sx={{ color: '#233098', fontSize: '20px' }} />
//                                 </InputAdornment>
//                             ),
//                             sx: {
//                                 color: '#233098',
//                                 '& .MuiOutlinedInput-root': {
//                                     fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     '& fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                     '&:hover fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                     '&.Mui-focused fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                 },
//                             },
//                         }}
//                         sx={{
//                             marginBottom: { xs: '5px', md: 0 },
//                             marginRight: { md: '10px' },
//                             input: { color: '#233098', fontSize: '16px' },
//                             width: { xs: '100%', md: '250px' }
//                         }}
//                     />
//                     <TextField
//                         variant="outlined"
//                         placeholder="Enter your phone number"
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <Phone sx={{ color: '#233098', fontSize: '20px' }} />
//                                 </InputAdornment>
//                             ),
//                             sx: {
//                                 color: '#233098',
//                                 '& .MuiOutlinedInput-root': {
//                                     fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     '& fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                     '&:hover fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                     '&.Mui-focused fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                 },
//                             },
//                         }}
//                         sx={{
//                             marginBottom: { xs: '5px', md: 0 },
//                             marginRight: { md: '10px' },
//                             input: { color: '#233098', fontSize: '16px' },
//                             width: { xs: '100%', md: '250px' },
//                             fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                         }}
//                     />
//                     <TextField
//                         variant="outlined"
//                         placeholder="Enter your email"
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <Email sx={{ color: '#233098', fontSize: '20px' }} />
//                                 </InputAdornment>
//                             ),
//                             sx: {
//                                 color: '#233098',
//                                 '& .MuiOutlinedInput-root': {
//                                     fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     '& fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                     '&:hover fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                     '&.Mui-focused fieldset': {
//                                         borderColor: '#233098',
//                                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                                     },
//                                 },
//                             },
//                         }}
//                         sx={{
//                             marginBottom: { xs: '5px', md: 0 },
//                             marginRight: { md: '10px' },
//                             input: { color: '#233098', fontSize: '16px' },
//                             width: { xs: '100%', md: '250px' }
//                         }}
//                     />
//                     <Button variant="contained" sx={{
//                         backgroundColor: '#233098',
//                         color: 'white',
//                         height: '56px',
//                         fontSize: '14px',
//                         fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
//                         width: { xs: '100%', md: '250px' },
//                         '&:hover': { backgroundColor: '#233098' }
//                     }}>
//                         SUBSCRIBE NOW
//                     </Button>
//                 </Box>
//             </Box>

//             {/* Main Content Section */}
//             <Box sx={{ padding: '20px' }}>
//                 <Grid container spacing={2}> {/* Reduced grid spacing */}
//                     <Grid item xs={12} sm={3}>
//                         <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>ABOUT COMPANY</Typography>
//                         <hr style={{ border: '1px solid #684df4', width: '70px', margin: '0', marginBottom: '8px' }} />
//                         <Typography sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }} >
//                             Professionally redefine transparent ROI through low-risk high-yield imperatives.
//                             Progressively create empowered, cost-effective users via team driven.
//                         </Typography>
//                         <Box sx={{ display: 'flex', marginTop: '8px' }}>
//                             <Link href="#" color="inherit" sx={{ ...commonStyles, marginRight: '8px', '&:hover': { color: '#684df4' } }}><Facebook /></Link>
//                             <Link href="#" color="inherit" sx={{ ...commonStyles, marginRight: '8px', '&:hover': { color: '#684df4' } }}><Twitter /></Link>
//                             <Link href="#" color="inherit" sx={{ ...commonStyles, marginRight: '8px', '&:hover': { color: '#684df4' } }}><Instagram /></Link>
//                             <Link href="#" color="inherit" sx={{ ...commonStyles, '&:hover': { color: '#684df4' } }}><LinkedIn /></Link>
//                         </Box>
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                         <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>QUICK LINKS</Typography>
//                         <hr style={{ border: '1px solid #684df4', width: '70px', margin: '0', marginBottom: '8px' }} />
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>About Us</Link>
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Team</Link>
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>FAQ</Link>
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Projects</Link>
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Contact Us</Link>
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                         <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>IT SERVICES</Typography>
//                         <hr style={{ border: '1px solid #684df4', width: '70px', margin: '0', marginBottom: '8px' }} />
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Web Development</Link> {/* Reduced margin bottom */}
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Business Development</Link>
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Product Management</Link>
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>UI/UX Design</Link>
//                         <Link href="#" color="inherit" display="block" sx={{ ...commonStyles, marginBottom: '4px', '&:hover': { color: '#684df4' }, textDecorationLine: 'none', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Cloud Services</Link>
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                         <Typography variant="h6" sx={{ ...commonStyles, marginBottom: '8px', fontWeight: 'bold', color: '#fff' }}>Contact Us</Typography>
//                         <hr style={{ border: '1px solid #684df4', width: '70px', margin: '0', marginBottom: '8px' }} />
//                         <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff' }}>
//                             <EmailIcon sx={{ marginRight: '8px' }} />
//                             <Box>
//                                 <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Email:</Typography>
//                                 <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>info@sninfosystems.com</Typography>
//                             </Box>
//                         </Box>
//                         <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff' }}>
//                             <PhoneIcon sx={{ marginRight: '8px' }} />
//                             <Box>
//                                 <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Phone:</Typography>
//                                 <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>+91 9740857368</Typography>
//                             </Box>
//                         </Box>
//                         <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
//                             <WhatsAppIcon sx={{ marginRight: '8px' }} />
//                             <Box>
//                                 <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>WhatsApp:</Typography>
//                                 <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>+91 9740857368</Typography>
//                             </Box>
//                         </Box>
//                         <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#fff' }}>
//                             <LocationOnIcon sx={{ marginRight: '8px' }} />
//                             <Box>
//                                 <Typography variant="body1" sx={{ ...commonStyles, fontWeight: 'bold', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Address:</Typography>
//                                 <Typography variant="body2" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>Basavanagudi,Bangaluru,Karnataka</Typography>
//                             </Box>
//                         </Box>
//                     </Grid>
//                 </Grid>
//             </Box>

//             {/* Footer Bottom Section */}
//             <Box sx={{ textAlign: 'center', padding: '10px' }}>
//                 <Typography sx={{ fontWeight: 700, color: '#fff', fontSize: '14px', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
//                     Copyright &copy; 2026 SN Info Systems. All Rights Reserved.
//                 </Typography>
//             </Box>
//         </Box>
//     );
// };

// export default Footer;
